import * as Sentry from "@sentry/astro";

if (typeof window !== 'undefined') {
  Sentry.init({
    dsn: "https://9eecbe977cc21b4d5bb7af76b9ef7d2b@o4511388485086336.ingest.us.sentry.io/4511388410904576",
    sendDefaultPii: false, // SECURITY: Never send PII to third-party logs

    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    // Capture 100% of performance transactions for due diligence
    tracesSampleRate: 1.0,
  });
}
